// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607020804/js/" + chunkId + "." + {"44":"4a2b444b","225":"3cc03fa7","481":"a9c670a3","486":"596600db","770":"8c4dd8c9"}[chunkId] + ".0.09003735467777174.chunk.js";
};